// src/components/ui/Skeleton.tsx - Skeleton loaders для AchievementsPage

import styled, { keyframes } from 'styled-components';

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

export const Skeleton = styled.div<{ width?: string; height?: string }>`
  width: ${props => props.width || '100%'};
  height: ${props => props.height || '20px'};
  background: linear-gradient(
    90deg,
    rgba(123, 104, 238, 0.1) 25%,
    rgba(123, 104, 238, 0.2) 50%,
    rgba(123, 104, 238, 0.1) 75%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s ease-in-out infinite;
  border-radius: 8px;
`;

export const SkeletonCard = styled.div`
  background: linear-gradient(135deg,
    rgba(255, 255, 255, 0.95),
    rgba(255, 255, 255, 0.8)
  );
  backdrop-filter: blur(20px);
  border: 1px solid rgba(123, 104, 238, 0.15);
  border-radius: 20px;
  padding: 18px;
  margin-bottom: 14px;
  
  @media (max-width: 375px) {
    padding: 16px;
    border-radius: 16px;
  }
`;

export const SkeletonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 12px;
`;

export const SkeletonCircle = styled(Skeleton)`
  border-radius: 50%;
  flex-shrink: 0;
`;

export const SkeletonText = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;